export class Product {
	
	title;
	subTitle;
	slug;
	content;
	excerpt;
	url;
	price;
	type;
	color;
	info;
	date;
	image;
	pdf;
	gallery;
	exhibitions;
	news;
	
	constructor (object)
	{
		// Identifier
		this.id = object.id || null;
		this.title = object.title.rendered || null;
		this.slug = object.slug || null;

		// Settings
		// this.color = object.meta_box.settings.color || null;
		
		// content
		this.date = object.date || null;
		this.subTitle = object.meta_box.content.sub_title || null;
		this.content = object.meta_box.content.content || null;
		this.excerpt = object.meta_box.content.short_content || null;
		this.info = object.meta_box.credits.info || null;
		
		// Product
		this.image = object.meta_box.content.image || null;
		this.gallery = object.meta_box.content.gallery || [];
		this.pdf = object.meta_box.content.pdf || null;
		
		// Buy
		this.url = object.meta_box.settings.url || null;
		this.price = object.meta_box.settings.price || null;
		this.type = object.meta_box.settings.type || null;

		// Relations
		this.exhibitions = object.meta_box.news_to_exhibitions_to || null;
		this.news = object.meta_box.news_to_products_to || null;
	}
}


// WEBPACK FOOTER //
// ./src/data/classes/product.class.js